import {
  getExtraServicesLoadingStatus,
  loadExtraServices,
  useAppDispatch,
  useAppSelector,
  withAsyncThunkErrorHandling,
} from '@lib/store';
import {useEffect} from 'react';

export const useExtraServicesLoader = () => {
  const dispatch = useAppDispatch();

  const loadingStatus = useAppSelector(getExtraServicesLoadingStatus);

  useEffect(() => {
    if (loadingStatus === 'NotLoaded') {
      dispatch(withAsyncThunkErrorHandling(() => loadExtraServices()));
    }
  }, [loadingStatus, dispatch]);

  return loadingStatus;
};
